import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, CreateMaintenanceRequestDto,MaintenanceApi, MaintenanceRequestDto, MaintenanceRequestSearchParamsDTO} from "@inosio/payments-sdk";
import { IpaUserExtended, selectCurrentUser } from "../../../shared/sagas/auth/authSlice";
import {
  getAllMaintenanceRequests,
  getCreateMaintenanceRequest,
  getInProgressMaintenanceRequests,
  setAllMaintenanceRequests,
  setInProgressMaintenanceRequestFetchError,
  setInProgressMaintenanceRequests,
  setMaintenanceRequestCreationError,
  setMaintenanceRequestFetchError,
  setNewMaintenanceRequest,
} from "./MaintenanceSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;

export function requestCreateMaintenanceRequest(accessToken: string, createMaintenanceRequestDto: CreateMaintenanceRequestDto) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });
  const ipaMaintenanceApi = new MaintenanceApi(apiConfig);
  return ipaMaintenanceApi.createMaintenanceRequest(createMaintenanceRequestDto);
}

export function requestMaintenanceRequests(accessToken: string, requester_uuid: string, maintenanceRequestSearchParamsDTO: MaintenanceRequestSearchParamsDTO) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });
  const ipaMaintenanceApi = new MaintenanceApi(apiConfig);
  return ipaMaintenanceApi.fetchAllMaintenanceRequests(requester_uuid, maintenanceRequestSearchParamsDTO);
}

export function* handleCreateMaintenanceRequest(action: { type: typeof getCreateMaintenanceRequest; payload: CreateMaintenanceRequestDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<MaintenanceRequestDto> = yield call(requestCreateMaintenanceRequest, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setNewMaintenanceRequest(data));
  } catch (error: any) {
    yield put(
      setMaintenanceRequestCreationError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* handleFetchAllMaintenanceRequests(action: { type: typeof getAllMaintenanceRequests; payload: { requesterUuid: string; params: MaintenanceRequestSearchParamsDTO } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestMaintenanceRequests, currentUser.accessToken, action.payload.requesterUuid, action.payload.params);
    const { data } = response;
    yield put(setAllMaintenanceRequests(data));
  } catch (error: any) {
    yield put(
      setMaintenanceRequestFetchError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* handleFetchInProgressMaintenanceRequests(action: { type: typeof getAllMaintenanceRequests; payload: { requesterUuid: string; params: MaintenanceRequestSearchParamsDTO } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestMaintenanceRequests, currentUser.accessToken, action.payload.requesterUuid, action.payload.params);
    const { data } = response;
    yield put(setInProgressMaintenanceRequests(data));
  } catch (error: any) {
    yield put(
      setInProgressMaintenanceRequestFetchError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* maintenanceSaga() {
  yield takeLatest(getCreateMaintenanceRequest.type, handleCreateMaintenanceRequest);
  yield takeLatest(getAllMaintenanceRequests.type, handleFetchAllMaintenanceRequests);
  yield takeLatest(getInProgressMaintenanceRequests.type, handleFetchInProgressMaintenanceRequests);
}
